import { Partner } from "../../amorg-common";
import { colors, ColorSystem } from './color';
import { creceaColors } from "./creceaColors";
import { joblifeColors } from "./joblifeColors";

// --------------------------------------------------------------------------
// the styled components theme object is extended with this object
// in the styled.d.ts file
//
// the type of the customizable colors object in props.theme
//// ------------------------------------------------------------------------
export type CustomizableColors = {
    
    // Buttons and containers
    primary:{
        light:string,
        normal:string,
        dark:string,
    },

    secondary:string,

    active:{
        default:{ normal:string, hover:string },
        dark:{ normal:string, hover:string },
    },

    mainNavigation:{
        background:string,
        backgroundSelected:string,
        divider:string,
        color:string,
        colorSelected:string
    },

    button?:{
        filled:{
            background:string,
            backgroundHover:string,
        },
        outlined:{
            border:string,
            text:string,
            textHover:string,
            backgroundHover:string,
        },
        text:{
            text:string,
            textHover:string,
            backgroundHover:string,
        },
        light:{
            text:string,
            textHover:string,
            background:string,
            backgroundHover:string,
        }
    },

    tabber:{
        avatarBackground:string,
        selectionColor:string,
        hoverColor:string
    }
}

// Helper for resolving a color selection
export function applyPartnerColors(partner?:Partner)
{
    if(partner === 'Crecea')
    {
        customizeColors(colors, creceaColors);
    }

    if(partner === 'Joblife')
    {
        customizeColors(colors, joblifeColors);
    }
}

function customizeColors(colors:ColorSystem, custom:CustomizableColors)
{
    colors.mainNavigation = custom.mainNavigation;
    
    colors.tabber.hover.background = custom.tabber.hoverColor;
    colors.tabber.selected.background = custom.tabber.selectionColor;
    colors.tabber.avatarBackground = custom.tabber.avatarBackground;

    if(custom.button)
    {
        colors.button.filled = {
            ...colors.button.filled,
            background: custom.button.filled.background,
            backgroundHover: custom.button.filled.backgroundHover,
        };

        colors.button.outlined = {
            ...colors.button.outlined,
            border:`1px solid ${custom.button.outlined.border}`,
            text:custom.button.outlined.text,
            textHover:custom.button.outlined.textHover,
            backgroundHover:custom.button.outlined.backgroundHover,
        };

        colors.button.text = {
            ...colors.button.text,
            text:custom.button.text.text,
            textHover:custom.button.text.textHover,
            backgroundHover:custom.button.text.backgroundHover,
        };

        colors.button.light = {
            ...colors.button.light,
            text:custom.button.light.text,
            textHover:custom.button.light.textHover,
            background:custom.button.light.background,
            backgroundHover:custom.button.light.backgroundHover,
        };
    }
    else
    {
        colors.button.filled = {
            ...colors.button.filled,
            background: custom.primary.normal,
            backgroundHover: custom.primary.dark,
        };

        colors.button.outlined = {
            ...colors.button.outlined,
            border:`1px solid ${custom.primary.light}`,
            text:custom.primary.dark,
            textHover:custom.primary.dark,
        };

        colors.button.text = {
            ...colors.button.text,
            text:custom.primary.dark,
            textHover:custom.primary.dark,
            backgroundHover:custom.primary.light,
        };

        colors.button.light = {
            ...colors.button.light,
            text:custom.primary.dark,
            textHover:custom.primary.dark,
            background:custom.primary.light,
            backgroundHover:custom.primary.normal,
        };
    }

    colors.card.light.default.background = custom.primary.normal;
    colors.card.light.hover.background = custom.primary.light;
    colors.card.attention.default.background = custom.secondary;

    colors.customForm.answer.formFieldCard.cardHeader.background = custom.primary.dark;
    colors.customForm.answer.formFieldCard.cardHeader.text = 'white';


    colors.link.dark.normal = custom.active.dark.normal;
    colors.link.dark.hover = custom.active.dark.hover;
    
    colors.link.default.normal = custom.active.default.normal;
    colors.link.default.hover = custom.active.default.hover;

    colors.graphs.activityTimeline.getColor = (/*type*/) =>
    {
        return custom.primary.normal;
    }
}